import type { GetLikedFoldersParams, GetLikedFoldersResponse } from './types';
import { defaultHttpClient } from 'shared/src/api/httpClient';

/**
 * - 20개씩 pagination
 * - 서랍 정보를 가져오는 api
 */
export const getLikedFolders = async ({
  last_sno,
}: GetLikedFoldersParams = {}) => {
  return defaultHttpClient
    .request<GetLikedFoldersResponse>({
      method: 'GET',
      url: '/api/v2/members/me/liked_folders/',
      params: {
        last_sno,
      },
    })
    .then(result => result.data);
};
